"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildCommentRefined = void 0;
const buildCommentRefined = (commentProperties) => ({
    ID: commentProperties.ID,
    metadata: {
        created: commentProperties.metadata.created,
        updated: commentProperties.metadata.updated,
    },
    resource: commentProperties.resource,
    type: commentProperties.type,
    comment: commentProperties.comment,
});
exports.buildCommentRefined = buildCommentRefined;
//# sourceMappingURL=CommentRefined.js.map